import React, { useEffect, useState } from "react";
import {
  AddButton,
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import { useFormik, Form, FormikProvider } from "formik";
import {
  Autocomplete,
  Box,
  Button,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import {
  getCroLeadsAll,
  getCroLeadStatusNew,
  UpdateStudentStatus,
} from "../../../redux/features/croSlice";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import {
  changeStudentStatus,
  getBatchAdmissionRegister,
} from "../../../redux/features/batchSlice";

const CROStudentStatus = ({ rowData, dispatchParams, open, setOpen }) => {
  //   const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { croLeadStatusNew } = useSelector((state) => state.cro);
  const { loading } = useSelector((state) => state.batch);
  const { paginationData } = useSelector((state) => state.globalDataGrid);

  const ValidationSchema = Yup.object().shape({
    cro_lead_status: Yup.string().required("Update Student Status"),
  });

  const getStatusIdFromName = (name) => {
    const match = croLeadStatusNew.find(
      (status) => status.cro_lead_status_name === name
    );
    return match ? match.cro_lead_status_id : "";
  };

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      cro_assignment_id: rowData?.cro_assignment_id,
      cro_lead_status: getStatusIdFromName(rowData?.cro_lead_status_name),
      cro_remarks: rowData?.croRemarks,
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      dispatch(changeStudentStatus(values)).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getBatchAdmissionRegister(dispatchParams));
          setOpen(false);
          dispatch(
            savePaginationData({ ...paginationData, openAnchor: false })
          );
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  useEffect(() => {
    if (open) {
      dispatch(getCroLeadStatusNew());
    }
  }, [open]);

  return (
    <GlobalDialog
      title={"Update Student Status"}
      open={open}
      setOpen={setOpen}
      fullWidth
      closeButton={true}
      //   popupButton={
      //     <UpdateButton size="medium" action={() => setOpen(true)}>
      //       Update
      //     </UpdateButton>
      //   }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  {/* <GlobalSelectField
                    options={{
                      formik,
                      name: "cro_lead_status",
                      label: "Lead Status",
                      data: croLeadStatusNew,
                      keys: {
                        id: "cro_lead_status_id",
                        value: "cro_lead_status_name",
                      },
                    }}
                  /> */}
                  <TextField
                    select
                    fullWidth
                    label="Student Status"
                    name="cro_lead_status"
                    value={formik.values.cro_lead_status}
                    onChange={formik.handleChange}
                  >
                    {croLeadStatusNew.map((status) => (
                      <MenuItem
                        key={status.cro_lead_status_id}
                        value={status.cro_lead_status_id}
                      >
                        {status.cro_lead_status_name}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    fullWidth
                    label="Remarks"
                    name="cro_remarks"
                    multiline
                    rows={2}
                    value={formik.values.cro_remarks}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <Button
                      size="small"
                      color="secondary"
                      variant="outlined"
                      onClick={() => setOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      disabled={loading}
                      size="small"
                      type="submit"
                    >
                      {loading ? "Please wait..." : "Save"}
                    </Button>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default CROStudentStatus;
